<template>
  <div>
    <div v-if="Object.keys(editVersion).length == 0 && isFlagUpload" class="uploadHelm">
      <div class="fileUpload">
        <el-upload
class="upload-demo"
:action="api"
:show-file-list="false"
multiple
:limit="3"
          :on-success="uploadSuccess"
:on-error="uploadError"
:before-upload="uploadBefore">
          <img src="../../../../assets/images/fileIcon.svg" alt="" />
          <p>上传Helm配置文件</p>
          <p>文件格式支持 tar.gz 和 tgz</p>
        </el-upload>
      </div>
    </div>
    <div v-else>
      <el-form ref="form" :rules="rules" :model="appDetail" label-width="80px">
        <el-form-item label="应用名称" prop="name">
          <el-input v-model="appDetail.name" style="width: 200px;" disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="应用版本" prop="version">
          <el-input v-model="appDetail.version" style="width: 200px;" disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="架构" prop="arch">
          <el-checkbox-group v-model="appDetail.arch">
                    <el-checkbox v-for="arch in checkedArchArr" :label="arch" :key="arch">{{ arch }}</el-checkbox>
                </el-checkbox-group>
        </el-form-item>
        <el-form-item label="版本描述" prop="versiondesc">
          <textarea v-model="appDetail.versiondesc" style="width: 400px;padding: 10px;border: 1px solid #e3e3e3;border-radius: 6px;" ></textarea>
        </el-form-item>
        <el-form-item prop="introduction" label="版本详情">
          <MdEditor :content.sync="appDetail.introduction"></MdEditor>
        </el-form-item>
        <el-form-item>
          <el-button class="save_btn" type="primary" @click="onSubmit" :loading="Loading">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { uploadWarehouse, saveVersion } from '@/api/app';
import { mapState } from 'vuex';
export default {
  name: 'AppHelmCreate',
  props: {
    marketID: String,
    dialogVisible: Boolean,
    onClose: Function,
    onSuccess: Function,
    appType: String,
    appID: String,
    editVersion: Object,
    editFun: Function
  },
  components: {},
  data() {
    var baseDomain = process.env.BASE_API;
    if (baseDomain == '/') {
      baseDomain = window.location.origin;
    }
    return {
      mode: 'default',
      centerDialogVisible: false,
      checkedArchArr: ['arm64', 'amd64'],
      Loading: false,
      fileList: [],
      isFlagUpload: true,
      api: `${baseDomain}/app-server/markets/${this.marketID}/apps/${this.appID}/helm/uploads`,
      uploadDetalis: {},
      iconUpload: false,
      vsDescription: '',
      appDetail: {
        introduction: '',
        versiondesc: '',
        arch: []
      },
      editor: null,
      toolbarConfig: {
        excludeKeys: ['uploadVideo', 'fullScreen', 'emotion']
      },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            customUpload: this.uploadImg
          }
        }
      },
      rules: {
        version: [
          { required: true, message: '请输入版本号', trigger: 'blur' }
        ],
        arch: [
          { required: false, message: '请选择架构', trigger: 'blur' }
        ],
        introduction: [
          { required: true, message: '请输入版本详情', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入应用名称', trigger: 'blur' }
        ]
        // versiondesc: [
        //   { required: false, message: '请输入版本描述', trigger: 'blur' },
        // ],
      }
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo
    }),
    myorgs() {
      return this.$store.state.user.userOrgs;
    }
  },
  created() {
    if (Object.keys(this.editVersion).length > 0) {
      this.appDetail.versiondesc = this.editVersion.desc
      this.appDetail.introduction = this.editVersion.detail
      this.appDetail.arch = this.editVersion.arch
      this.appDetail.name = this.editVersion.versionAlias
      this.appDetail.version = this.editVersion.version
    }
  },
  mounted() {
  },
  methods: {
    uploadImg(file, insertFn) {
      const imgData = new FormData();
      imgData.append('file', file);
      axios({
        url: this.uploadConfig.api,
        method: 'post',
        data: imgData
      }).then((response) => {
        insertFn(response.data.FileURL);
      });
    },
    onCreated(editor) {
      this.editor = Object.seal(editor);
    },
    vsDescriptionChange() {
      this.uploadDetalis.versionDescription = this.vsDescription
    },
    onSubmit() {
      this.Loading = true;
      this.uploadDetalis.versionDescription = this.appDetail.versiondesc
      this.uploadDetalis.detail = this.appDetail.introduction
      this.uploadDetalis.arch = this.appDetail.arch && this.appDetail.arch.length > 0 ? this.appDetail.arch.join(',') : ''
      if (Object.keys(this.editVersion).length > 0) {
        const obj = {
          marketID: this.marketID,
          appID: this.appID,
          version: this.appDetail.version,
          enable: this.editVersion.enable,
          description: this.appDetail.versiondesc,
          versionAlias: this.appDetail.name,
          is_plugin: this.editVersion.is_plugin,
          templateType: this.editVersion.templateType,
          cmd: this.editVersion.cmd || '',
          detail: this.appDetail.introduction,
          arch: this.appDetail.arch && this.appDetail.arch.length > 0 ? this.appDetail.arch.join(',') : ''
        };
        this.editFun(obj)
      } else {
        saveVersion({ marketID: this.marketID, appID: this.appID, value: this.uploadDetalis })
          .then((res) => {
            this.isFlagUpload = true,
            this.Loading = false
            this.$message({
              message: '创建版本成功',
              type: 'success'
            });
            this.onSuccess()
          }).catch((err) => {
            this.isFlagUpload = true,
            this.Loading = false
            this.$message({
              message: '创建版本失败',
              type: 'error'
            });
          })
      }
    },
    close() {
      this.isFlagUpload = true
      this.onClose && this.onClose();
    },
    uploadSuccess(file, fileList) {
      uploadWarehouse({ marketID: this.marketID, appID: this.appID, path: file.bean.FileURL })
        .then((res) => {
          this.isFlagUpload = false;
          this.uploadDetalis = res.bean
          this.appDetail.name = this.uploadDetalis.name
          this.appDetail.version = this.uploadDetalis.version
          this.iconUpload = false;
          this.$message({
            message: '上传成功',
            type: 'success'
          });
        })
        .catch((err) => {
          this.iconUpload = false;
          this.$message({
            message: '上传失败',
            type: 'error'
          });
        });

    },
    uploadError() {
      this.iconUpload = false
      this.$message({
        message: '上传失败',
        type: 'error'
      });
    },
    uploadBefore() {
      this.iconUpload = true

    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.uploadHelm {
  width: 210px;
  margin: 0 0 20px 80px;
  display: flex;
  align-items: center;

  .iconUpload {
    width: 90px;
  }

  .fileUpload {
    width: calc(100% - 90px);
    margin-left: 12px;
  }
}

.dialog {}

::v-deep .el-dialog__body {
  min-height: 300px;
}

::v-deep .upload-demo .el-upload {
  color: #415d94 !important;
  font-weight: 600 !important;
  border: 2px dashed #d9d9d9 !important;
  border-radius: 6px !important;
  cursor: pointer !important;
  position: relative !important;
  overflow: hidden !important;
  text-align: center !important;
  padding: 20px !important;
  background-color: #fafafa !important;
  transition: border-color 0.3s !important;
  min-height: 100px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
}

::v-deep .upload-demo .el-upload:hover {
  border-color: #409eff !important;
}

::v-deep .upload-demo .el-upload p {
  margin: 8px 0 !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  color: #415d94 !important;
}

::v-deep .upload-demo .el-upload img {
  width: 40px !important;
  height: 40px !important;
  margin-bottom: 10px !important;
}

/* 控制 MdEditor 中的图片尺寸 */
::v-deep .md-editor img {
  max-width: 100% !important;
  max-height: 300px !important;
  width: auto !important;
  height: auto !important;
  object-fit: contain !important;
  border-radius: 4px !important;
}

/* 控制富文本编辑器中的图片 */
::v-deep .w-e-text-container img {
  max-width: 100% !important;
  max-height: 300px !important;
  width: auto !important;
  height: auto !important;
  object-fit: contain !important;
  border-radius: 4px !important;
}

::v-deep .el-upload__tip {
  color: #8d8d8d;
  font-size: 12px;
  margin-top: 5px;
}

.helmInfo {
  width: 100%;
  padding: 0px 12px 12px;
  min-height: 300px;
  h3 {
    font-weight: 550;
  }

  p {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: 40px;
      height: 40px;
    }

    p {
      font-size: 12px;
      color: #999999;
      margin-top: 10px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/generalUser/publishApp/components/appHelmCreate.vue